<template>
  <div class="steps">
    <div class="steps__header">
      <div class="steps__header__lines">
        <div class="steps__header__line--default"></div>
        <div class="steps__header__line">
          <transition name="filters-bounce">
            <div v-if="!isFirstStep" class="steps__header__line--green"></div>
          </transition>
          <transition name="filters-bounce">
            <div v-if="!isFirstStep && !isSecondStep" class="steps__header__line--green"></div>
          </transition>
        </div>
      </div>

      <div class="steps__header__content">
        <div class="steps__header__content__step">
          <div class="steps__header__content__step__number steps__header__content__step__number--green">1</div>
          <p class="steps__header__content__step__text">Selección</p>
        </div>

        <div class="steps__header__content__step">
          <div v-bind:class="{ 'steps__header__content__step__number--green': !isFirstStep, 'steps__header__content__step__number--grey': isFirstStep}" class="steps__header__content__step__number">2</div>
          <p class="steps__header__content__step__text">Mensaje</p>
        </div>

        <div class="steps__header__content__step">
          <div v-bind:class="{ 'steps__header__content__step__number--green': !isFirstStep && !isSecondStep, 'steps__header__content__step__number--grey': isFirstStep || isSecondStep}" class="steps__header__content__step__number">3</div>
          <p class="steps__header__content__step__text">Confirmación</p>
        </div>
      </div>
    </div>

    <div class="steps__content">
      <Filters v-if="isFirstStep"></Filters>
      <Email v-if="isSecondStep"></Email>
      <Resume v-if="isThirdStep"></Resume>
      <!--Payment v-if="isFourthStep"></Payment-->
      <Sended v-if="isFourthStep"></Sended>
    </div>

    <div class="steps__footer">
      <div class="steps__footer__right" v-bind:class="{ 'steps__footer__right--no-right-margin': isFourthStep }">
        <sm-button
          label="Ir a inicio"
          size="large"
          @click="finalStepReset('/')"
          v-show="isFourthStep"
        />
        <sm-button
          label="Ver estado de solicitudes"
          size="large"
          @click="finalStepReset('/prospects')"
          v-show="isFourthStep"
        />
        <sm-button
          label="Siguiente"
          size="medium"
          secondary
          @click="goToNextStep"
          v-show="!isFourthStep && !isThirdStep"
        />
        <sm-button
          label="Confirmar"
          size="medium"
          secondary
          @click="handleConfirm"
          v-show="isThirdStep && !isLoading"
        />
        <sm-button
          label="Confirmar"
          size="medium"
          disabled
          v-show="isThirdStep && isLoading"
        />
      </div>
      <div class="steps__footer__left">
        <sm-button
          label="Anterior"
          size="medium"
          outline
          @click="goToPrevStep"
          v-show="!isFirstStep && !isFourthStep && !isLoading"
        />
        <sm-button
          label="Anterior"
          size="medium"
          disabled
          v-show="!isFirstStep && !isFourthStep && isLoading"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Filters from '@/components/Filters'
import Email from '@/components/Email'
import Resume from '@/components/confirmation/Resume'
// import Payment from '@/components/confirmation//Payment'
import Sended from '@/components/confirmation//Sended'

export default {
  name: 'steps',
  components: {
    Filters,
    Email,
    Resume,
    // Payment,
    Sended
  },
  computed: {
    isFirstStep () {
      return this.$store.getters.isFirstStep
    },
    isSecondStep () {
      return this.$store.getters.isSecondStep
    },
    isThirdStep () {
      return this.$store.getters.isThirdStep
    },
    isFourthStep () {
      return this.$store.getters.isFourthStep
    },
    isFifthStep () {
      return this.$store.getters.isFifthStep
    },
    isFilterActive () {
      return this.$store.getters.isFilterActive
    },
    theWizard () {
      return this.$store.getters.theWizard
    },
    maybeUsers () {
      return this.$store.getters.maybeUsers
    },
    isLoading () {
      return this.$store.getters.isLoading
    }
  },
  methods: {
    goToPrevStep () {
      this.$store.commit('goToPrevStep')
    },
    goToNextStep () {
      if (this.isFilterActive && this.maybeUsers.total) {
        this.$store.commit('goToNextStep')
      }
    },
    handleConfirm () {
      this.$store.dispatch('batchesPurchase')
    },
    finalStepReset (path) {
      this.$store.dispatch('finalStepReset', path)
    }
  }
}
</script>

<style>
.steps__header__lines {
  position: relative;
  top: 1px;
  width: calc(100% - 100px);
}

.steps__header__line {
  display: flex;
  flex-direction: row;
  height: 10px;
  position: absolute;
  top: 0px;
  width: 100%;
}

.steps__header__line--default {
  background-color: #f2f2f2;
  height: 5px;
  width: 100%;
}

.steps__header__line--green {
  background-color: #00B19D;
  height: 5px;
  width: 50%;
}

.filters-bounce-enter-active {
  animation: filters-bounce-in 0.5s;
  animation-timing-function: linear;
}

.filters-bounce-leave-active {
  animation: filters-bounce-in 0.5s reverse;
  animation-timing-function: linear;
}

@keyframes filters-bounce-in {
  0% {
    width: 0;
  }
  50% {
    width: 25%;
  }
  100% {
    width: 50%;
  }
}

.steps {
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 0px 0px 2px rgba(0,0,0,0.1);
  height: 100%;
  margin: 30px 55px 50px 55px;
  width: calc(100% - 110px);
}

.steps__header {
  align-items: center;
  background-color: #f9fafd;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 35px 10px 0px 10px;
}

.steps__header__content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}

.steps__header__content__step {
  width: 100px;
}

.steps__header__content__step__number {
  color: #ffffff;
  font-size: 14px;
  font-weight: bold;
  line-height: 33.5px;
  text-align: center;

  background-color: #00b19d;
  border-radius: 50%;
  height: 33.5px;
  left: 30px;
  position: relative;
  top: -20px;
  transition: background-color 1s;
  width: 33.5px;
}

.steps__header__content__step__number--green {
  background-color: #00b19d;
}

.steps__header__content__step__number--grey {
  color: #00535e;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 33.5px;

  background-color: #f2f2f2;
}

.steps__header__content__step__text {
  color: #00b19d;
  font-size: 12px;
  font-weight: normal;

  left: -42px;
  position: relative;
  top: -10px;
  width: 180px;
}

.steps__content {
  background-color: #ffffff;
  height: 100%;
  margin: 0 50px;
  padding: 30px 0px;
  width: calc(100% - 100px);
}

.steps__footer {
  border-width: 1px 0 0 0;
  border-style: solid;
  border-color: #f2f2f2;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  margin: 0 20px;
  padding: 20px 0;
}

.steps__footer__left {
  float: left;
  position: relative;
  width: fit-content;
  margin-left: 30px;
}

.steps__footer__right {
  display: flex;
  flex-direction: row;
  float: right;
  justify-content: space-between;
  position: relative;
  width: 350px;
  margin-right: -100px;
}

.steps__footer__right--no-right-margin {
  margin-right: 0px;
}
</style>
